import * as S from './Home.styled';

function Home() {
	return (
		<div>
            <S.Home>
                메인화면
            </S.Home>
        </div>
    );

}

export default Home;